import type { ReactNode } from 'react';

import type { TNavbarMenuListGroupElement } from '@shared/dream-components';
import { NavbarMenuListGroup as NavbarMenuListGroupElement } from '@shared/dream-components';

interface Props {
  node: TNavbarMenuListGroupElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuListGroup = ({ node, children, screen }: Props) => {
  return (
    <NavbarMenuListGroupElement element={node} screen={screen}>
      {children}
    </NavbarMenuListGroupElement>
  );
};

export default NavbarMenuListGroup;
